module.exports = __webpack_public_path__ + "img/banner2.3de2b65c.png";